import { AloftPrice, MonthlyAbodeAggregate } from '@aloft/toolkit-shared';

export const convertMarketAggregateDataToPDFTableColumns = (
  entries: MonthlyAbodeAggregate[]
):  [string[], ...(string | string[])[][]] => {
  const processedEntries = entries.map((entry) => ({
    month: entry.month.substring(0, 7),
    absorptionRate: entry.absorption_rate ? `${(entry.absorption_rate * 100).toFixed(2)}%` : 'N/A',
    totalComparableSales: entry.total_comparable_sales?.toString() ?? 'N/A',
    totalActiveListings: entry.total_active_properties?.toString() ?? 'N/A',
    monthsOfHousingSupply: entry.months_supply ? entry.months_supply.toFixed(2) : 'N/A',
    medianCompSalePrice: entry.median_sale_price ? AloftPrice.schema.parse(entry.median_sale_price).toString(true) : 'N/A',
    medianListPrice: entry.median_list_price ? AloftPrice.schema.parse(entry.median_list_price).toString(true) : 'N/A',
    medianCompSaleToListPricePercentage: entry.median_sale_price && entry.median_list_price
      ? `${(AloftPrice.schema.parse(entry.median_sale_price).toDollarLike() * 100 / AloftPrice.schema.parse(entry.median_list_price).toDollarLike()).toFixed(2)}%`
      : 'N/A',
    medianDOM: entry.median_days_on_market ? entry.median_days_on_market.toString() : 'N/A',
  }));

  return [
    ['Inventory', ...processedEntries.map((data) => String(data.month))],
    [
      'Total # of Comp. Sales (Settled)',
      ...processedEntries.map((data) => String(data.totalComparableSales)),
    ],
    [
      'Absorption Rate',
      ...processedEntries.map((data) => String(data.absorptionRate)),
    ],
    [
      'Total # of Comp. Active Listings',
      ...processedEntries.map((data) => String(data.totalActiveListings)),
    ],
    [
      'Months of Housing Supply',
      ...processedEntries.map((data) => String(data.monthsOfHousingSupply)),
    ],
    [
      'Median Comp. Sale Price',
      ...processedEntries.map((data) => String(data.medianCompSalePrice)),
    ],
    [
      'Median Comp. List Price (Active Listings)',
      ...processedEntries.map((data) => String(data.medianListPrice)),
    ],
    [
      'Median Comp. Sale Price as % of List Price',
      ...processedEntries.map((data) => String(data.medianCompSaleToListPricePercentage)),
    ],
    [
      'Median DOM',
      ...processedEntries.map((data) => String(data.medianDOM)),
    ]
  ];
};
